import { create } from "zustand";
import { TemplateItem } from "../../types/types";
import apiClient from "../service/apiClient";

interface TemplateStore {
  items: TemplateItem[];
  isLoading: boolean;
  error: unknown;
  fetchItems: () => Promise<void>;
}

export const useTemplateStore = create<TemplateStore>((setState, getState) => ({
  items: null,
  isLoading: false,
  error: null,

  fetchItems: async () => {
    if (getState().isLoading) return;

    setState({ isLoading: true, error: null, items: null });
    try {
      const response = await apiClient.get("/template");
      setState({ items: response.data.items });
    } catch (err: unknown) {
      setState({ error: err });
    } finally {
      setState({ isLoading: false });
    }
  },
}));
